import {PLANET_BLUE} from '@apps-common/ui-theme/Colors';
import {scale as chromaScale} from 'chroma-js';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';

export const COLOR_SCALE = [
  '#FEE6F0',
  '#FC99C2',
  '#F94D93',
  '#F70065',
  '#B5004A',
];

export const clipStyle = new Style({
  stroke: new Stroke({
    width: 1,
    color: 'rgba(0,0,0,0)',
  }),
});

export const fill = new Fill({
  color: 'transparent',
});

export const selectStyle = new Style({
  stroke: new Stroke({
    color: '#FAD40F',
    width: 2,
  }),
  fill,
});

export const scale = chromaScale(COLOR_SCALE);
export const getGeometryStyle = color => feature => {
  const score = feature.get('score');
  const inScene = feature.get('inScene');

  const hasScore = typeof score !== 'undefined';

  const defaultColor = hasScore ? scale(score).hex() : PLANET_BLUE[500];

  const fill = hasScore ? new Fill({color: 'transparent'}) : null;

  let stroke;
  if (inScene === false) {
    stroke = new Stroke({
      color: color || defaultColor,
      width: 1,
      lineDash: [1, 2],
    });
  } else {
    stroke = new Stroke({
      color: color || defaultColor,
      width: 2,
    });
  }

  return new Style({fill, stroke});
};

export const geometryStyle = getGeometryStyle();

export const heatMapGradient = [
  ['#1a9641', '#a6d96a', '#ffffbf', '#fdae61', '#d7191c'],
  ['#a6611a', '#dfc27d', '#f5f5f5', '#80cdc1', '#018571'],
  ['#ffffcc', '#a1dab4', '#41b6c4', '#2c7fb8', '#253494'],
  ['#f1eef6', '#d7b5d8', '#df65b0', '#dd1c77', '#980043'],
  ['#ffffb2', '#fecc5c', '#fd8d3c', '#f03b20', '#bd0026'],
];

export const getDrawStyle = (color = '#009DB1') => {
  return [
    new Style({
      stroke: new Stroke({
        color: '#FFFFFF',
        width: 3,
        zIndex: 0,
      }),
    }),
    new Style({
      stroke: new Stroke({
        color,
        width: 1,
        zIndex: 1,
      }),
    }),
  ];
};
